import { z } from "zod";

export const createApiKeySchema = z
	.object({
		name: z.string().trim().min(1, { message: "Name is required" }).max(120, { message: "Name must be at most 120 characters" }),
		expires_at: z.iso.datetime().nullable().optional(),
	})
	.strict();

export type CreateApiKeyPayload = z.infer<typeof createApiKeySchema>;

export interface CreateApiKeyResponse {
	id: string;
	name: string;
	key_prefix: string;
	plain_token: string;
	expires_at: string | null;
	created_at: string;
}
